<template>

  <div>

    <div style="display: flex; align-items: center; justify-content: end; margin-bottom: 10px;">

      <button class="button is-small" @click="allActivated = !allActivated">
        <span v-if="!allActivated" class="material-symbols-outlined">expand_all</span>
        <span v-else class="material-symbols-outlined">collapse_all</span>
        {{ allActivated ? 'alle einklappen' : 'alle aufklappen' }}
      </button>

    </div>

    <!--
    <lang labelKey="APO_TAB-CONFIG"></lang><br>
    <lang labelKey="SITE-PWA-HEADING-BASE_DATA"></lang><br>
    <lang labelKey="SITE-PWA-HEADING-APPEARANCE"></lang><br>
    <lang labelKey="SITE-PWA-HEADING-SHOP_SETTINGS"></lang><br>
    <lang labelKey="SITE-PWA-TEXT_INJECTIONS"></lang><br>

    <lang labelKey="SITE-PWA-HEADING-SERVICES"></lang><br>
    <lang labelKey="SITE-PWA-HEADING-OTHER"></lang><br>
    <lang labelKey="SITE-PWA-HEADING-VISIBILITIES"></lang><br><br>
    -->

    <collapse accordion :key="allActivated">

      <!-- base data -->
      <collapse-item ref="baseDataCollapse" :title="$t('SITE-PWA-HEADING-BASE_DATA')" :actived="allActivated || afterWizardCollapsed">

        <form-input label="SITE-PWA-NAME" :showInfoText="false" inputType="text" v-model="value.name"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-STREET" :showInfoText="false" inputType="text" v-model="value.street"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-ZIPCODE" :showInfoText="false" inputType="text" v-model="value.zipcode"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-CITY" :showInfoText="false" inputType="text" v-model="value.city"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <form-input label="SITE-PWA-EMAIL" :showInfoText="false" inputType="email" v-model="value.email"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-EMAIL_PREORDER" :showInfoText="true" inputType="email" v-model="value.emailPreorder"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-EMAIL_CONTACT" :showInfoText="true" inputType="email" v-model="value.emailContact"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <form-input label="SITE-PWA-TEL" :showInfoText="true" inputType="text" v-model="value.tel"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-FAX" :showInfoText="true" inputType="text" v-model="value.fax"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <!--
        <form-input
          label="SITE-PWA-OPENING_HOURS"
          :showInfoText="true"
          inputType="textarea"
          :textareaAutosize="true"
          v-model="value.openingHours"
          :is-horizontal="true">
        </form-input>
        -->

        <!-- OPENING HOURS -->
        <div class="control is-horizontal wide">

          <div class="control-label">
            <label-name labelKey="SITE-PWA-OPENING_HOURS"></label-name>
          </div>


          <div class="openingHours">

            <div v-for="day in weekDays" class="day" :key="day">

              <div class="openingHoursLabel">
                <lang :labelKey="`WEEKDAY-SHORT-${day}`"></lang>
              </div>

              <div>
                <div class="select-boxes">

                  <div class="selectBoxLabel">
                    Offen
                  </div>

                  <div class="row-50">

                    <form-input inputType="select" :selectOptions="openingHoursOptions" :selectReturnSingleValue="true"
                      :showLabelInOptions="false" :selectAllowEmpty="false"
                      v-model="value.openingHours[day].openingTime" inputSize="is-default"
                      :class="{ 'disabled': value.openingHours[day].openingTime == null }" :is-horizontal="false">
                    </form-input>

                  </div>

                  <div class="separator">bis</div>

                  <div class="row-50">

                    <form-input inputType="select" :selectOptions="openingHoursOptions" :selectReturnSingleValue="true"
                      :showLabelInOptions="false" :selectAllowEmpty="false"
                      v-model="value.openingHours[day].closingTime"
                      :class="{ 'disabled': value.openingHours[day].closingTime == null }" inputSize="is-default"
                      :is-horizontal="false">
                    </form-input>

                  </div>
                </div>

                <div class="select-boxes breaks">

                  <div class="selectBoxLabel">
                    Pause
                  </div>

                  <div class="row-50">

                    <form-input inputType="select" :selectOptions="openingHoursPauseOptions"
                      :selectReturnSingleValue="true" :showLabelInOptions="false" :selectAllowEmpty="false"
                      v-model="value.openingHours[day].breakStartTime"
                      :class="{ 'disabled': value.openingHours[day].breakStartTime == null }" inputSize="is-default"
                      :is-horizontal="false">
                    </form-input>

                  </div>
                  <div class="separator">bis</div>

                  <div class="row-50">

                    <form-input inputType="select" :selectOptions="openingHoursPauseOptions"
                      :selectReturnSingleValue="true" :showLabelInOptions="false" :selectAllowEmpty="false"
                      v-model="value.openingHours[day].breakEndTime"
                      :class="{ 'disabled': value.openingHours[day].breakEndTime == null }" inputSize="is-default"
                      :is-horizontal="false">
                    </form-input>

                  </div>
                </div>

              </div>



            </div>
          </div>
        </div>

        <br>

        <form-input label="SITE-PWA-COMPANY_REGISTER_NUMBER" :showInfoText="false" inputType="text"
          v-model="value.companyRegisterNo" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-UID_NUMBER" :showInfoText="false" inputType="text" v-model="value.UIDNo"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-PHARMACY_OWNER" :showInfoText="false" inputType="text" v-model="value.pharmacyOwner"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-DATA_PROTECTION_OFFICER" :showInfoText="false" inputType="text"
          v-model="value.dataProtectionOfficer" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-CONCESSIONAIRE" :showInfoText="false" inputType="text"
          v-model="value.concessionaire" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-BUSINESS_NAME" :showInfoText="false" inputType="text" v-model="value.businessName"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-BUSINESS_PURPOSE" :showInfoText="false" inputType="text"
          v-model="value.businessPurpose" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-PHARMACY_URL" :showInfoText="false" inputType="text" v-model="value.pharmacyURL"
          inputSize="is-default" :is-horizontal="true">
        </form-input>
      </collapse-item>

      <!-- appearance -->
      <collapse-item :title="$t('SITE-PWA-HEADING-APPEARANCE')" :actived="allActivated">

        <form-input label="SITE-PWA-USE_DARK_THEME" :showInfoText="true" inputType="switch" v-model="value.useDarkTheme"
          inputSize="is-default" :is-horizontal="true" v-if="isAdmin">
        </form-input>

        <form-input label="SITE-PWA-USE_ELEMENTOR_COLOR_SHEME" :showInfoText="true" inputType="switch"
          v-model="value.useElementorColorScheme" inputSize="is-default" :is-horizontal="true" v-if="isAdmin">
        </form-input>

        <template v-if="!value.useElementorColorScheme">

          <form-input label="SITE-PWA-COLORS-PRIMARY" :showInfoText="false" inputType="text"
            v-model="value.colors.primary" inputSize="is-default" :is-horizontal="true">
          </form-input>

          <form-input label="SITE-PWA-COLORS-SECONDARY" :showInfoText="false" inputType="text"
            v-model="value.colors.secondary" inputSize="is-default" :is-horizontal="true">
          </form-input>

          <form-input label="SITE-PWA-COLORS-ACCENT" :showInfoText="false" inputType="text"
            v-model="value.colors.accent" inputSize="is-default" :is-horizontal="true">
          </form-input>
          <br>
        </template>
        <br>
        <form-input label="SITE-PWA-SHOW_HOME_BUTTON" :showInfoText="true" inputType="switch"
          v-model="value.showHomeButton" inputSize="is-default" :is-horizontal="true">
        </form-input>

        
        <form-input 
          label="SITE-PWA-USE_WP_FOOTER_MENU" 
          :showInfoText="true" 
          inputType="switch" 
          v-model="value.useWpFooterMenu"
          inputSize="is-default" 
          :is-horizontal="true">
        </form-input>

        <form-input 
          label="SITE-PWA-COLLAPSIBLE_MOBILE_MENU_ITEMS" 
          :showInfoText="true" 
          inputType="switch" 
          v-model="value.collapsibleMobileMenuItems"
          inputSize="is-default" 
          :is-horizontal="true">
        </form-input>

        <footer-logos
          v-if="isAdmin"
          v-model="value.footerLogos">
        </footer-logos>

      </collapse-item>

      <!-- shop settings -->
      <collapse-item :title="$t('SITE-PWA-HEADING-SHOP_SETTINGS')" :actived="allActivated">

        <form-input label="SITE-PWA-HAS_SHOP" :showInfoText="false" inputType="switch" v-model="value.hasShop"
          :is-horizontal="true" inputSize="is-default" v-if="isAdmin">
        </form-input>

        <template v-if="value.hasShop">

          <form-input label="SITE-PWA-ERP" :showInfoText="false" inputType="select" :selectOptions="erpOptions"
            :showLabelInOptions="false" selectFieldName="name" selectReturnSingleValue="value" selectTrackBy="name" v-model="value.erp"
            :is-horizontal="true" inputSize="is-default" v-if="isAdmin">
          </form-input>



          <br>

          <form-input label="SITE-PWA-SEPA-ACCOUNT_OWNER" :showInfoText="false" inputType="text"
            v-model="value.accountOwner" inputSize="is-default" :is-horizontal="true">
          </form-input>

          <form-input label="SITE-PWA-SEPA-IBAN" :showInfoText="false" inputType="text" v-model="value.iban"
            inputSize="is-default" :is-horizontal="true">
          </form-input>

          <form-input label="SITE-PWA-SEPA-BIC" :showInfoText="false" inputType="text" v-model="value.bic"
            inputSize="is-default" :is-horizontal="true">
          </form-input>

          <br>

          <form-input label="SITE-PWA-SHOP_START_PAGE_CATEGORIES" :showInfoText="true" inputType="textarea"
            :textareaAutosize="true" v-model="shopStartPageCategories" :is-horizontal="true" inputSize="is-default"
            v-if="isAdmin">
          </form-input>

          <eigenmarken-kategorien
            v-model="value.eigenmarkenKategorien">
          </eigenmarken-kategorien>

          <br>

          <form-input label="SITE-PWA-HAS_SHIPMENT" :showInfoText="false" inputType="switch" v-model="value.hasShipment"
            :is-horizontal="true" inputSize="is-default" :isReadOnly="!isAdmin">
          </form-input>

          <template v-if="value.hasShipment">

            <form-input label="SITE-PWA-HAS_SHIPMENT_DRUGS" :showInfoText="true" inputType="switch"
              v-model="value.hasShipmentDrugs" inputSize="is-default" :is-horizontal="true">
            </form-input>


            <template v-if="value.hasShipmentDrugs">

              <form-input label="SITE-PWA-AGES_URL" :showInfoText="true" inputType="text" v-model="value.agesURL"
                inputSize="is-default" :is-horizontal="true">
              </form-input>
              <br>

            </template>


            <form-input label="SITE-PWA-HIDE_TAXES_FOREIGN_COUNTRIES" :showInfoText="true" inputType="switch"
              v-model="value.hideTaxesForeignCountries" inputSize="is-default" :is-horizontal="true">
            </form-input>

            <form-input label="SITE-PWA-ZIPCODE_CALCULATION_ACTIVE" :showInfoText="true" inputType="switch"
              v-model="value.zipcodeCalculationActive" inputSize="is-default" :is-horizontal="true">
            </form-input>

            <!--
            <form-input
              label="SITE-PWA-WITHDRAWAL_FORM_URL"
              :showInfoText="true"
              inputType="text"
              v-model="value.withdrawalFormUrl"
              inputSize="is-default"
              :is-horizontal="true">
            </form-input>
            ---->

          </template>

          <br>
          <registration-codes
            v-model="value.registrationCodes">
          </registration-codes>

          <br>
          <form-input label="SITE-PWA-PHARMACY_AVAILABILITIES" :showInfoText="true" inputType="switch" v-model="value.pharmacyAvailabilities"
          :is-horizontal="true" inputSize="is-default" :isReadOnly="!isAdmin"></form-input>

          <form-input label="SITE-PWA-ORDER_EMAILS_TO_SELECTED_PHARMACY" :showInfoText="true" inputType="switch" v-model="value.orderEmailsToSelectedPharmacy"
          :is-horizontal="true" inputSize="is-default" :isReadOnly="!isAdmin"></form-input>

          <br>
            
          <open-pickup-times
            v-if="isAdmin"
            v-model="value.openAndPickUpTimes"
            :base-opening-hours="value.openingHours">
          </open-pickup-times>


        </template>
      </collapse-item>

      <!-- text injections -->
      <collapse-item :title="$t('SITE-PWA-TEXT_INJECTIONS')" :actived="allActivated">

        <form-input label="SITE-PWA-IMPRINT_ADDITIONAL_TEXT" :showInfoText="true" inputType="text"
          v-model="value.imprintAdditionalText" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-TOC_ADDITIONAL_TEXT" :showInfoText="true" inputType="text"
          v-model="value.termsOfServiceAdditionalText" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-PRIVCACY_ADDITIONAL_TEXT" :showInfoText="true" inputType="text"
          v-model="value.privacyAdditionalText" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-BIRTHDAY_INO_TEXT" :showInfoText="true" inputType="text"
          v-model="value.birthdayInfoText" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <recipe-preorder-times
          v-model="value.recipePreorder">
        </recipe-preorder-times>

      </collapse-item>

      <!-- integrations, social media & external tools -->
      <collapse-item :title="$t('SITE-PWA-HEADING-INTEGRATIONS')" :actived="allActivated">

        <form-input label="SITE-PWA-SOCIAL_MEDIA-FACEBOOK" :showInfoText="false" inputType="text"
          v-model="value.socialMedia.facebook" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-SOCIAL_MEDIA-INSTAGRAM" :showInfoText="false" inputType="text"
          v-model="value.socialMedia.instagram" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <form-input label="SITE-PWA-GOOGLE_RECAPTCHA_KEY-PUBLIC" :showInfoText="false" inputType="text"
          v-model="value.googleReCaptcha.publicKey" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-GOOGLE_RECAPTCHA_KEY-SECRET" :showInfoText="false" inputType="text"
          v-model="value.googleReCaptcha.secretKey" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <br>

        <form-input label="SITE-PWA-GOOGLE_TAG_MANAGER_ID" :showInfoText="false" inputType="text"
          v-model="value.googleTagManagerID" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-GOOGLE_MAPS_URL" :showInfoText="true" inputType="text" v-model="value.googleMapsURL"
          inputSize="is-default" :is-horizontal="true" v-if="isAdmin">
        </form-input>

        <form-input label="SITE-PWA-FACEBOOK_PAGE_ID" :showInfoText="false" inputType="text"
          v-model="value.facebookPageID" inputSize="is-default" :is-horizontal="true">
        </form-input>

      </collapse-item>


      <!-- features -->
      <collapse-item :title="$t('SITE-PWA-HEADING-FEATURES')" :actived="allActivated">

        <form-input label="SITE-PWA-HAS_APOKAT" :showInfoText="true" inputType="switch" v-model="value.hasApokat"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-HAS_RECALL_SERVICE" :showInfoText="true" inputType="switch"
          v-model="value.hasRecallService" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <recall-times
          v-if="value.hasRecallService"
          v-model="value.recallTimes">
        </recall-times>

        <br><br>

        <form-input label="SITE-PWA-HIDE_RECIPE_UPLOAD" :showInfoText="true" inputType="switch"
          v-model="hideRecipeUpload" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-HIDE_CONTACT_FORM" :showInfoText="true" inputType="switch" v-model="hideContactForm"
          inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-HIDE_BEREITSCHAFT" :showInfoText="true" inputType="switch"
          v-model="hideBereitschaft" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-ACTIVATE_MEDICATION_PLANNER" :showInfoText="true" inputType="switch"
          v-model="value.activateMedicationPlanner" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input label="SITE-PWA-ACTIVATE_AVAILABILITY_QUERY" :showInfoText="true" inputType="switch"
          v-model="value.activateAvailabilityQuery" inputSize="is-default" :is-horizontal="true">
        </form-input>

        <form-input v-if="isAdmin" label="SITE-PWA-ACTIVATE_LOYALTY_CARD" :showInfoText="true" inputType="switch" v-model="value.loyaltyCard"
          inputSize="is-default" :is-horizontal="true"
          confirmText="Achtung, ein Deaktivieren dieser Funktion führt zu folgenden ...<br>Möchten Sie die Kundenkarten wirklich deaktivieren ?"></form-input>

      </collapse-item>


      <!-- Loyalty Card Settings -->
      <collapse-item v-if="isAdmin && value.loyaltyCard" :title="$t('SITE-PWA-HEADING-LOYALTY_CARD')" :actived="allActivated">
          
          <form-input 
            label="SITE-PWA-CONVERSION_RATE" 
            :showInfoText="true" 
            inputType="slider"
            v-model="loyaltyPointsPerEuroProxy" 
            inputSize="is-default"
            :minValue="1"
            :maxValue="100"
            :is-horizontal="true">
          </form-input>

          <form-input 
            label="SITE-PWA-LOYALTY_POINTS_REGISTRATION_BONUS" 
            :showInfoText="true" 
            inputType="slider"
            v-model="value.loyaltyPointsRegistrationBonus" 
            inputSize="is-default"
            :minValue="0"
            :maxValue="10000"
            :is-horizontal="true">
          </form-input>

        <form-input label="SITE-PWA-GOOGLE_WALLET_CLASS_ID" :showInfoText="true" inputType="text"
          v-model="value.loyaltyCardGoogleClassIdSuffix" inputSize="is-default" :is-horizontal="true">
        </form-input>

          <loyalty-card-multipliers
            :site="value"
            :multipliers-data="multipliersData"
            @update:multipliers-data="onMultipliersDataUpdate">
          </loyalty-card-multipliers>


      </collapse-item>

    </collapse>


  </div>

</template>



<script>
import loyaltyCardMultipliers from './incl-pharmacy-pwa-config-multipliers.vue'
import openPickupTimes from './incl-pharmacy-open-pickup-times.vue'
import recipePreorderTimes from './incl-pharmacy-recipe-preorder-times.vue'
import footerLogos from './incl-pharmacy-footer-logos.vue'
import eigenmarkenKategorien from './incl-pharmacy-eigenmarken-kategorien.vue'
import registrationCodes from './incl-pharmacy-registration-codes.vue'
import recallTimes from './incl-pharmacy-recall-times.vue'
export default {

  name: 'pwaConfig',

  components: {
    loyaltyCardMultipliers,
    openPickupTimes,
    recipePreorderTimes,
  footerLogos,
  eigenmarkenKategorien,
  registrationCodes,
  recallTimes
  },

  props: {

    value: {
      type: Object,
      default: () => { }
    },
    afterWizardCollapsed: {
      type: Boolean,
      default: false
    },
    site: {
      type: Object,
      default: () => { }
    },

    loyaltyPointsPerEuro: {
      type: Number,
      default: 1,
    },

    erpOptions: {
      type: Array,
      default: () => []
    }

  },


  data() {

    return {
      isLoading: true,
      allActivated: false,
      sliderValue: 10,
    }

  },

  created() {

    if (!this.value) {
      this.value = {}
    }

    if (!this.value.siteId || !this.value.nightDutyDatesSiteId) {
      this.value.siteId = this.value.nightDutyDatesSiteId = this.site.id;
    }
    if (!this.value.key || !this.confelasticSearchKey) {
      this.value.key = this.value.elasticSearchKey = this.site.apopointKey;
    }
    if (!this.value.erp) {
      this.value.erp = this.site.erp;
    }
    if (!this.value.street) {
      this.value.street = this.site.address;
    }
    if (!this.value.zipcode) {
      this.value.zipcode = this.site.zipcode;
    }
    if (!this.value.city) {
      this.value.city = this.site.city;
    }    
    if (!this.value.colors) {
      this.value.colors = { primary: null, secondary: null, accent: null }
    }
    if (!this.value.googleReCaptcha) {
      this.value.googleReCaptcha = { publicKey: null, secretKey: null }
    }
    if (!this.value.socialMedia) {
      this.value.socialMedia = { facebook: null, instagram: null }
    }
    if(typeof this.value.orderEmailsToSelectedPharmacy === 'undefined') {
      this.$set(this.value, 'orderEmailsToSelectedPharmacy', false);
    }
    if(typeof this.value.pharmacyAvailabilities === 'undefined') {
      this.$set(this.value, 'pharmacyAvailabilities', false);
    }
    if (typeof this.value.recallTimes === 'string') {
      try {
        this.value.recallTimes = JSON.parse(this.value.recallTimes);
      } catch (e) {
        this.value.recallTimes = {};
      }
    } else if (!this.value.recallTimes || typeof this.value.recallTimes !== 'object' || Array.isArray(this.value.recallTimes)) {
      this.$set(this.value, 'recallTimes', {});
    }

    if (typeof this.value.registrationCodes === 'string') {
      try {
        this.value.registrationCodes = JSON.parse(this.value.registrationCodes);
      } catch (e) {
        this.value.registrationCodes = {};
      }
    } else if (!this.value.registrationCodes || typeof this.value.registrationCodes !== 'object' || Array.isArray(this.value.registrationCodes)) {
      this.$set(this.value, 'registrationCodes', {});
    }

    if (typeof this.value.eigenmarkenKategorien === 'string') {
      try {
        this.value.eigenmarkenKategorien = JSON.parse(this.value.eigenmarkenKategorien);
      } catch (e) {
        this.value.eigenmarkenKategorien = [];
      }
    } else if (!this.value.eigenmarkenKategorien || !Array.isArray(this.value.eigenmarkenKategorien)) {
      this.$set(this.value, 'eigenmarkenKategorien', []);
    }

    if (typeof this.value.footerLogos === 'string') {
      try {
        this.value.footerLogos = JSON.parse(this.value.footerLogos);
      } catch (e) {
        this.value.footerLogos = [];
      }
    } else if (!this.value.footerLogos || !Array.isArray(this.value.footerLogos)) {
      this.$set(this.value, 'footerLogos', []);
    }

    if (typeof this.value.recipePreorder === 'string') {
      try {
        this.value.recipePreorder = JSON.parse(this.value.recipePreorder);
      } catch (e) {
        this.value.recipePreorder = {};
      }
    } else if (!this.value.recipePreorder) {
      this.$set(this.value, 'recipePreorder', {});
    }

    if (typeof this.value.openAndPickUpTimes === 'string') {
      try {
        this.value.openAndPickUpTimes = JSON.parse(this.value.openAndPickUpTimes);
      } catch (e) {
        this.value.openAndPickUpTimes = {};
      }
    } else if (!this.value.openAndPickUpTimes && this.value.openAndPickupTimes) {
      this.value.openAndPickUpTimes = typeof this.value.openAndPickupTimes === 'string'
        ? JSON.parse(this.value.openAndPickupTimes)
        : this.value.openAndPickupTimes;
    }


    if (typeof this.value.openingHours == 'string' || typeof this.value.openingHours == 'undefined') {

      this.value.openingHours = {
        'Monday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '18:00'
        },
        'Tuesday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '18:00'
        },
        'Wednesday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '18:00'
        },
        'Thursday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '18:00'
        },
        'Friday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '18:00'
        },
        'Saturday': {
          openingTime: '08:00',
          breakStartTime: null,
          breakEndTime: null,
          closingTime: '12:00'
        },
        'Sunday': {
          openingTime: null,
          breakStartTime: null,
          breakEndTime: null,
          closingTime: null
        },
      }


    }

  },

  computed: {

    loyaltyPointsPerEuroProxy: {
      get() {
        return this.loyaltyPointsPerEuro;
      },
      set(newValue) {
        this.$emit('update:loyaltyPointsPerEuro', newValue);
      }
    },

    weekDays() {
      return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    },

    times() {
      var times = [];
      var quarterHours = ["00", "15", "30", "45"];

      for (var i = 0; i < 24; i++) {
        for (var j = 0; j < 4; j++) {
          var time = i + ":" + quarterHours[j];
          if (i < 10) {
            time = "0" + time;
          }
          times.push(
            {
              name: time,
              value: time
            }
          );
        }
      }
      return times;

    },

    openingHoursOptions() {
      return [
        {
          name: "geschlossen",
          value: null
        },
        ...this.times
      ];
    },

    openingHoursPauseOptions() {

      return [
        {
          name: "-",
          value: null
        },
        ...this.times
      ];

    },

    isAdmin() {
      // return this.activeUser.admin == true;
      // return this.activeUser.userRole.name === 'Administrator JTM'
      return ['Administrator', 'Administrator JTM'].indexOf(this.activeUser.userRole.name) > -1;
    },

    shopStartPageCategories: {
      get() {
        return JSON.stringify(this.value.shopStartPageCategories, null, 2);
      },
      set(newValue) {
        this.value.shopStartPageCategories = newValue == null || newValue == "" ? {} : JSON.parse(newValue);
      }
    },

    recipePreorder: {
      get() {
        return JSON.stringify(this.value.recipePreorder, null, 2);
      },
      set(newValue) {
        this.value.recipePreorder = newValue == null || newValue == "" ? {} : JSON.parse(newValue);
      }
    },

    openAndPickUpTimes: {
       get() {
        return JSON.stringify(this.value.openAndPickUpTimes, null, 2);
      },
      set(newValue) {
        this.value.openAndPickUpTimes = newValue == null || newValue == "" ? {} : JSON.parse(newValue);
      }
    },

    // negate this field --> https://jtm-digital.atlassian.net/browse/HEDI-866
    hideBereitschaft: {
      get() {
        return !this.value.hideBereitschaft || false;
      },
      set(newValue) {
        this.value.hideBereitschaft = !newValue;
      }
    },

    // negate this field --> https://jtm-digital.atlassian.net/browse/HEDI-866
    hideContactForm: {
      get() {
        return !this.value.hideContactForm || false
      },
      set(newValue) {
        this.value.hideContactForm = !newValue;
      }
    },

    // negate this field --> https://jtm-digital.atlassian.net/browse/HEDI-866
    hideRecipeUpload: {
      get() {
        return !this.value.hideRecipeUpload || false
      },
      set(newValue) {
        this.value.hideRecipeUpload = !newValue;
      }
    },


  },

  methods: {
    onMultipliersDataUpdate(newData) {
      this.$emit('update:multipliers-data', newData);
    }
  }

}

</script>

<style lang="scss" scoped>



.button {
  span {
    font-size: 12px;
    margin-right: 4px;
  }
}



.section-header {
  padding: 0 0 6px 0;
  text-transform: uppercase;

  .label {
    color: #999;
  }
}

    ::v-deep .vue-treeselect__multi-value-item {
        color: #000;
        background: #F5F7F9;
    }
    ::v-deep .vue-treeselect__value-remove {
        color: #aaa;
    }
    ::v-deep .collapse-wrap {
      margin-bottom: 80px;

      .card {

        border: 0;
        box-shadow: none;
        margin-bottom: 14px;
        border-radius: 4px;

        &:not(.is-active) {
          .card-header {
            background-color: #F5F5F5;
            border-radius: 4px;
          }
        }

        .card-header {
          box-shadow: none;
          border: 0;
          background-color: #E2E2E2;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }

        .card-content {
          background-color: #F5F5F5;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
    }
}

.openingHours {
  min-width: 150px;
  max-width: 450px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  flex-direction: row;

  .day {
    position: relative;
    width: 100%;
    background-color: #F0F0F0;
    border-radius: 2px;
    padding: 36px 10px 10px 10px;
  }

  .openingHoursLabel {
    font-size: 12px;
    text-transform: uppercase;
    color: #666;
    font-weight: bold;
    background-color: #E8E8E8;
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 8px 6px;
    line-height: 1;
    border-top-left-radius: 2px;
  }

  .select-boxes {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 2px 6px;

    &.breaks {
      margin-top: 8px;


    }

    .selectBoxLabel {
      display: flex;
      align-items: center;
      font-size: 10px;
      text-transform: uppercase;
      color: #AAA;
      width: 60px;
    }


    .separator {
      text-align: center;
      flex: 0;

      font-size: 12px;
      color: #AAA;
      display: flex;
      align-items: center;
    }

    .row-50 {
      flex: 1;

      ::v-deep .control {
        margin: 0;
        min-width: auto;
        max-width: 100%;
        width: 100%;

        .singleSelect {
          min-width: 100% !important;
          max-width: 100% !important;
        }

        &.disabled {
          .singleSelect .multiselect__tags {
            background-color: #dedede;

            .multiselect__single {
              background-color: transparent;
            }
          }
        }

      }

    }
  }


}
.section {
  margin: 0 0 32px 0;
  padding: 24px 16px;
  width: 100%;
  max-width: 1024px;
  background-color: #F5F5F5;
  border-radius: 4px;
}

section {
  
    div.sectionLabel {
      font-size: 20px;
      margin-bottom: 32px;
    }

    padding: 20px;

    margin-bottom: 15px;
    border-bottom: 2px solid #F5F7F9;

    .control {

        display: flex;
        max-width: 800px !important;
        min-width: 100px;

        .multiselect {
            max-width: 100% !important;
            margin-bottom: 0 !important;
        }

        /*
        ::v-deep .control-label {
            flex-grow: 0 !important;
            flex-basis: 180px !important;
        }


        ::v-deep .control {
            display: flex;
            justify-content: center;
            flex-grow: 1;
            max-width: none;
            margin-bottom: 0 !important;
            min-width: 100px;
        }
        .vue-treeselect {
          white-space: wrap;
        }
        */

    }
}
</style>